import React from 'react';
import SearchInput from '../../../../v2BaseComponents/SearchInput';
import { getIntl } from '../../../../../utils/intl';

const intl = getIntl('FilesScreenSearch', {
    search: 'Search Files...',
});

export type SearchFieldOwnProps = {
    value: string;
    onChange: (newValue: string) => void;
};

export type SearchFieldProps = SearchFieldOwnProps;

const SearchField: React.FC<SearchFieldProps> = (props) => {
    return (
        <SearchInput
            debounceInterval={500}
            value={props.value}
            onChange={props.onChange}
            placeholder={intl('search')}
        />
    );
};

export default React.memo(SearchField);
